import { render } from "./TerminiCondizioniView.vue?vue&type=template&id=31d83248"
import script from "./TerminiCondizioniView.vue?vue&type=script&lang=js"
export * from "./TerminiCondizioniView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__